import { render, staticRenderFns } from "./StreamData.vue?vue&type=template&id=6b7fe040&scoped=true"
import script from "./StreamData.vue?vue&type=script&lang=js"
export * from "./StreamData.vue?vue&type=script&lang=js"
import style0 from "./StreamData.vue?vue&type=style&index=0&id=6b7fe040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7fe040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
